import { render, staticRenderFns } from "./AllInOneSearch.vue?vue&type=template&id=45aff25e&scoped=true"
import script from "./AllInOneSearch.vue?vue&type=script&lang=js"
export * from "./AllInOneSearch.vue?vue&type=script&lang=js"
import style0 from "./AllInOneSearch.vue?vue&type=style&index=0&id=45aff25e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45aff25e",
  null
  
)

export default component.exports